import React from 'react';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
import { is } from '../../services';
/**
 * Timeline Component
 * @param notifications {boolean} Timeline notification rendering
 * @param children {ReactNode}
 * - --------------- WEB PROPERTIES ----------------------------------
 * @param horizontal {boolean} timeline horizontal
 * @param className {string} Additionnal CSS Classes
 */
const Timeline = ({ className, notifications, horizontal, ...others }) => {
    const { styled } = useTrilogyContext();
    const timelineRef = React.useRef(null);
    const classes = hashClass(styled, clsx('timeline', notifications && notifications, horizontal && is('horizontal'), className));
    React.useEffect(() => {
        if (!horizontal && timelineRef.current) {
            const items = [
                ...timelineRef.current.querySelectorAll(`.${hashClass(styled, 'timeline-item')}`),
            ];
        }
    }, [timelineRef, horizontal]);
    return React.createElement("div", { ref: timelineRef, className: classes, ...others });
};
export default Timeline;
//# sourceMappingURL=Timeline.js.map